import { render, staticRenderFns } from "./afterService.vue?vue&type=template&id=040fe250&scoped=true"
import script from "./afterService.vue?vue&type=script&lang=js"
export * from "./afterService.vue?vue&type=script&lang=js"
import style0 from "./afterService.vue?vue&type=style&index=0&id=040fe250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fe250",
  null
  
)

export default component.exports